module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point01_02_travel-518a8b3680b0107cac077216b996075a.jpg";